import React from 'react';
import defaultImg from '../../../../../assets/images/default-article.png';
import { DEFAULT_SOCIAL_MEDIA_IMG } from '../../../utils/contants';
import date from 'date-and-time';
import { findAsset } from '../../../utils';

export const OpportunityCard = ({ opportunity, isSocial }) => {
	const { opportunity_locations, name, description, assets } = opportunity;
	const headerMediaUrl = findValidImage(assets);

	const previewMediaUrl = isSocial ? DEFAULT_SOCIAL_MEDIA_IMG : defaultImg;

	const Tags = () => {
		if (opportunity.opportunity_types.length === 0) {
			return null;
		}
		return (
			<div className="tags-container row">
				<div className="column button-group">
					{opportunity.opportunity_types.map(({ name, id }) => {
						{
							return (
								<div key={id} className="tag-button">
									<a
										href={`/organizations?interest_area=${id}`}
									>
										<p className="body-font">{name}</p>
									</a>
								</div>
							);
						}
					})}
				</div>
			</div>
		);
	};

	return (
		<div
			className="columns small-12 dashboard-card organization-card card"
			style={{ overflow: 'visible' }}
		>
			<a
				href={generateOpportunityLink(opportunity)}
				className="follow-btn-link"
			>
				<div className="row media-container">
					<img
						alt={`${name} Logo`}
						className="opportunity-card-img"
						src={headerMediaUrl ? headerMediaUrl : previewMediaUrl}
					/>
				</div>
				<div className="title-container">
					<strong>{name}</strong>
				</div>
				{getDateRange(
					opportunity.timeframe_start_on,
					opportunity.timeframe_end_on
				)}
				<br></br>
				{getOpportunityLocations(opportunity_locations)}
				<div className="details-container">
					<p className="cut-text">{description}</p>
				</div>
			</a>
			<Tags />
		</div>
	);
};

// UNTILS
const getOpportunityLocations = (opportunity_locations) => {
	if (!opportunity_locations) {
		return '';
	}

	let locationText = '';

	opportunity_locations.map(({ location }) => {
		locationText += `${location}, `;
	});

	const displayedLocations = locationText.slice(0, -2);

	return displayedLocations;
};

function generateOpportunityLink(opportunity) {
	if (!opportunity) {
		return;
	}
	const { organization_id, id: opportunity_id } = opportunity;
	const link = `/organizations/${organization_id}/property_info/opportunities/${opportunity_id}`;

	return link;
}

function getDate(input) {
	const dateObj = new Date(input.replace(/-/g, '/')); // replace - with / because JS Date reduces date by 1 day
	return date.format(dateObj, 'MMM DD, YYYY');
}

export function getDateRange(startDate, endDate) {
	if (!startDate && endDate) {
		return getDate(endDate);
	}

	if (!endDate && startDate) {
		return getDate(startDate);
	}

	if (!endDate || !startDate) {
		return '';
	}

	const startDateString = getDate(startDate);
	const endDateString = getDate(endDate);

	return `${startDateString} - ${endDateString}`;
}

function findValidImage(assets) {
	let validImage = null;

	const header_media = findAsset(assets, 'header_media');
	const body_media_1 = findAsset(assets, 'body_media_1');
	const body_media_2 = findAsset(assets, 'body_media_2');
	const sponsorship_deck = findAsset(assets, 'sponsorship_deck');

	if (header_media && isValidImage(header_media.url)) {
		return header_media.thumbnail_url || header_media.url;
	} else if (body_media_1 && isValidImage(body_media_1.url)) {
		return body_media_1.thumbnail_url || body_media_1.url;
	} else if (body_media_2 && isValidImage(body_media_2.url)) {
		return body_media_2.thumbnail_url || body_media_2.url;
	} else if (sponsorship_deck && isValidImage(sponsorship_deck.url)) {
		return sponsorship_deck.thumbnail_url || sponsorship_deck.url;
	}

	return validImage;
}

function isValidImage(format) {
	const validFormats = ['png', 'jpg', 'jpeg', 'gif', 'svg', 'webp'];
	if (!format) return false;

	return validFormats.some((validFormat) => {
		return format.endsWith(validFormat);
	});
}
